"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

exports.__esModule = true;
exports.bancomer = exports.bancomerMatcher = exports.bancomerParser = exports.trimMetaData = exports.parseNumber = exports.generateYnabDate = void 0;

require("mdn-polyfills/String.prototype.startsWith");

var papaparse_1 = require("../../util/papaparse");

var read_encoded_file_1 = require("../../util/read-encoded-file"); // Bancomer Row:
// DATE, DESCRIPTION, OUTFLOW, INFLOW, BALANCE

/*
 * Bancomer files are encoded as UTF16-LE. Since jschardet doesn't seem
 * to recognize that charset most of the time, we need to force it.
 */


exports.generateYnabDate = function (input) {
  var match = input.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);

  if (!match) {
    throw new Error('The input is not a valid date. Expected format: DD/MM/YYYY');
  }

  var day = match[1],
      month = match[2],
      year = match[3];
  return [month.padStart(2, '0'), day.padStart(2, '0'), year].join('/');
};

exports.parseNumber = function (input) {
  return Number(input.replace(',', ''));
};

exports.trimMetaData = function (input) {
  var lines = input.split('\n');
  return lines.splice(3).filter(function (l) {
    return l && l.trim() !== '' && !l.startsWith('     ') && !l.match(/^"BBVA (.+)"/);
  }).join('\n');
};

exports.bancomerParser = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var fileString, _a, data;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _a = exports.trimMetaData;
          return [4
          /*yield*/
          , read_encoded_file_1.readEncodedFile(file, 'utf16le')];

        case 1:
          fileString = _a.apply(void 0, [_b.sent()]);
          return [4
          /*yield*/
          , papaparse_1.parse(fileString, {
            delimiter: '\t'
          })];

        case 2:
          data = _b.sent().data;
          return [2
          /*return*/
          , [{
            data: data.filter(function (r) {
              return r[0] && r[0].trim();
            }).map(function (r) {
              return {
                Date: exports.generateYnabDate(r[0]),
                Memo: r[1],
                Outflow: r[2] ? exports.parseNumber(r[2]) : undefined,
                Inflow: r[3] ? exports.parseNumber(r[3]) : undefined
              };
            })
          }]];
      }
    });
  });
};

exports.bancomerMatcher = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var rawFileString, headerRow;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , read_encoded_file_1.readEncodedFile(file, 'utf16le')];

        case 1:
          rawFileString = _a.sent();

          if (rawFileString.length === 0) {
            return [2
            /*return*/
            , false];
          }

          if (rawFileString.startsWith('Card number: ') || rawFileString.startsWith('Número de Tarjeta: ')) {
            return [2
            /*return*/
            , true];
          } // This might happen when the file encoding is wrong.


          if (rawFileString.indexOf('\n') === -1) {
            return [2
            /*return*/
            , false];
          }

          headerRow = rawFileString.split('\n')[2].trim();

          if (headerRow === 'DATE\tDESCRIPTION\tOUTFLOW\tINFLOW\tBALANCE' || headerRow === 'FECHA\tDESCRIPCIÓN\tCARGO\tABONO\tSALDO') {
            return [2
            /*return*/
            , true];
          }

          return [2
          /*return*/
          , false];
      }
    });
  });
};

exports.bancomer = {
  name: 'bancomer',
  country: 'mx',
  fileExtension: 'csv',
  filenamePattern: /^descarga\.[c|t]sv$/,
  link: 'https://www.bancomer.com',
  match: exports.bancomerMatcher,
  parse: exports.bancomerParser
};